import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=3d80aaef&scoped=true&"
import script from "./ActiveFilters.vue?vue&type=script&lang=js&"
export * from "./ActiveFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d80aaef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d80aaef')) {
      api.createRecord('3d80aaef', component.options)
    } else {
      api.reload('3d80aaef', component.options)
    }
    module.hot.accept("./ActiveFilters.vue?vue&type=template&id=3d80aaef&scoped=true&", function () {
      api.rerender('3d80aaef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ActiveFilters.vue"
export default component.exports